module.exports = __webpack_public_path__ + "static/media/test.c7ee6cd8.png";